import { Trans, useTranslation } from 'react-i18next';
import classes from './Mechanical.module.scss';
import image_01 from '../../../assets/img/Portfolio/Mechanical/image_01.avif';
import image_02 from '../../../assets/img/Portfolio/Mechanical/image_02.avif';

const Mechanical = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={classes.titleWrap}>
                    <h2 className={`${classes.title} font-48`}>
                        <Trans>
                            {t('portfolio.mechanical.title')}
                        </Trans>
                    </h2>
                </div>
                <div className={classes.head}>
                    <p className={`${classes.text_01} font-20`}>
                        {t('portfolio.mechanical.text_01')}
                    </p>
                    <p className={`${classes.text_02} font-16`}>
                        {t('portfolio.mechanical.text_02')}
                    </p>
                </div>
                <div className={classes.blocks}>
                    <div className={`${classes.block} ${classes.block_01}`}>
                        <div>
                            <h4 className={`${classes.subtitle} font-20`}>
                                {t('portfolio.mechanical.block_01.subtitle')}
                            </h4>
                            <p className={`${classes.desc} font-16`}>
                                {t('portfolio.mechanical.block_01.desc')}
                            </p>
                        </div>
                        <img className={classes.image} src={image_01} alt='' />
                    </div>
                    <div className={`${classes.block} ${classes.block_02}`}>
                        <div>
                            <img className={`${classes.image} ${classes.imageMob}`} src={image_01} alt='' />
                            <img className={classes.image} src={image_02} alt='' />
                        </div>
                        <div>
                            <h4 className={`${classes.subtitle} font-20`}>
                                {t('portfolio.mechanical.block_02.subtitle')}
                            </h4>
                            <p className={`${classes.desc} font-16`}>
                                {t('portfolio.mechanical.block_02.desc')}
                            </p>
                        </div>
                    </div>
                </div>
                <div className={classes.bottom}>
                    <p className={`${classes.text} font-16`}>
                        {t('portfolio.mechanical.info')}
                    </p>
                    <div className={classes.line}></div>
                </div>
            </div>
        </section>
    );
};

export default Mechanical;
